import Configuration from '@/agilis/util/Configuration'
import DataTableV2Paginated from '@/agilis/components/DataTableV2Paginated/DataTableV2Paginated.vue'
import Title from '@/agilis/components/Title/Title.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'ProductTable',

  props: {
    propTitle: String
  },

  components: {
    DataTableV2Paginated,
    Title
  },

  computed: {
    ...mapGetters({
      applicationId: 'contextStore/applicationId',
      workspaceId: 'contextStore/workspaceId',
      trackerTypeId: 'contextStore/trackerTypeId'
    }),

    api () {
      return `/api/${this.applicationId}/product2`
    },

    configuration () {
      return Configuration.datatable.getDatatable({
        applicationId: this.applicationId,
        workspaceId: this.workspaceId,
        trackerTypeId: this.trackerTypeId
      })
    },

    computedDescription () {
      return this.$t('sales.label.productDescription')
    }

  }
}
